import { API_V2, axios, backEndAxios, restAxios } from './httpClient';
import { toGrantPayload } from '../helpers/grantRows';
import { toMaintenancePayload } from '../helpers/communityMaintenance';

export const createProduct = (body) => {
	const payload = {
		...body,
		activationDate: moment(body.activationDate, 'DD/MM/YYYY').tz('UTC', true).startOf('day').toISOString(),
		productAddons: body.productAddons?.map(toGrantPayload),
		maintenanceServices: body.maintenanceServices && toMaintenancePayload(body.maintenanceServices)
	};
	if (!payload.virtualAppliance) {
		delete payload.activationCode;
	}
	
	return restAxios.post(`/licensing/products`, payload);
};

export const updateProduct = (body) => {
	const payload = {
		...body,
		activationDate: moment(body.activationDate, 'DD/MM/YYYY').tz('UTC', true).startOf('day').toISOString(),
		productAddons: body.productAddons?.map(toGrantPayload),
		maintenanceServices: body.maintenanceServices && toMaintenancePayload(body.maintenanceServices)
	};
	if (!payload.virtualAppliance) {
		delete payload.activationCode;
	} else {
		// A virtual appliance's serial changes only through a move; a form opened before one would put the old serial
		// back, and a missing serial keeps the stored one (SYN-3453).
		delete payload.serialNumber;
	}

	return restAxios.patch(`/licensing/products/${payload.id}`, payload);
};

// Moves a virtual appliance's key, licenses and maintenance to the VM with this serial. The body carries no licenses,
// so no `version` either (SYN-3453).
export const moveProduct = (id, serialNumber) => {
	return restAxios.patch(`/licensing/products/${id}`, { serialNumber });
};


export const getProduct = (id) => {
	return restAxios.get(`/licensing/products/${id}`);
};

let getProductsController;
export const getProducts = (queryParams) => {
	// Cancel the previous request
	getProductsController?.abort();
	
	getProductsController = new AbortController();
	const searchParams = new URLSearchParams(queryParams).toString();
	return restAxios.get(`/licensing/products?${searchParams}`, {
		signal: getProductsController.signal
	});
};

export const getProductsBySerialNumber = (listOfSerialNumbers) => {
	const data = {
		serialNumbers: listOfSerialNumbers
	};
	return backEndAxios.post(`/centralBackend/${API_V2}/product/getProductsBySerialNumber`, data);
};

export const deleteProducts = (products) => {
	if (products.length === 1) {
		return restAxios.delete(`/licensing/products/${products[0].id}`);
	}

	return restAxios.post(`/licensing/products:batchDelete`, { ids: products.map((product) => { return product.id; }) });
};

export const generateActivationCode = () => {
	return axios.get('/products/activation-keys/generate');
};

export const getAssemblyTests = (serialNumber) => {
	const queryParams = {
		serialNumber: serialNumber,
		limit: 1
	};
	return restAxios.get(`/assembling/assembly-tests?${new URLSearchParams(queryParams).toString()}`);
};

// product addons

export const getProductAddons = () => {
	return restAxios.get('/licensing/addons');
};

export const getProductAddonDetails = (id) => {
	return restAxios.get(`/licensing/addons/${id}`);
};

export const createProductAddon = (body) => {
	return restAxios.post('/licensing/addons', body);
};

export const updateProductAddon = (id, body) => {
	return restAxios.patch(`/licensing/addons/${id}`, body);
};

export const deleteProductAddons = (body) => {
	return restAxios.post('/licensing/addons:batchDelete', { ids: body });
};

export const getProductAddonsByProductId = (productId) => {
	const queryParams = {
		productId: productId
	};
	return restAxios.get(`/licensing/product-addons?${new URLSearchParams(queryParams).toString()}`);
};
